﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {GeneratePlacesUrlOptions} from "./generatePlacesUrlOptions";

export function generateUrl(baseURL: string, value: string, options: GeneratePlacesUrlOptions, apiKey?: string): string {
	const delimiter = baseURL.includes("?") ? "&" : "?";
	let url = `${baseURL}${delimiter}text=${encodeURIComponent(value)}&format=json&type=amenity`;
	if (!isNullOrEmpty(apiKey)) {
		url += `&apiKey=${apiKey}`;
	}

	const {lang, filter, bias} = options;

	if (lang) {
		url += `&lang=${lang.split("-")[0]}`;
	}

	const filters = [];
	const filterByCountryCodes = filter?.country;
	const filterByCircle = filter?.circle;
	const filterByRect = filter?.rect;
	const filterByPlace = filter?.place;

	if (filterByCountryCodes && filterByCountryCodes.length) {
		filters.push(`countrycode:${filterByCountryCodes.join(",").toLowerCase()}`);
	}

	if (filterByCircle && isLatitude(filterByCircle.lat) && isLongitude(filterByCircle.lon) && filterByCircle.radiusMeters > 0) {
		filters.push(`circle:${filterByCircle.lon},${filterByCircle.lat},${filterByCircle.radiusMeters}`);
	}

	if (filterByRect && isLatitude(filterByRect.lat1) && isLongitude(filterByRect.lon1) && isLatitude(filterByRect.lat2) && isLongitude(filterByRect.lon2)) {
		filters.push(`rect:${filterByRect.lon1},${filterByRect.lat1},${filterByRect.lon2},${filterByRect.lat2}`);
	}

	if (filterByPlace) {
		filters.push(`place:${filterByPlace}`);
	}

	url += filters.length ? `&filter=${filters.join("|")}` : "";

	const biasParams = [];
	const biasByCountryCodes = bias?.country;
	const biasByCircle = bias?.circle;
	const biasByRect = bias?.rect;
	const biasByProximity = bias?.proximity;

	if (biasByCountryCodes && biasByCountryCodes.length) {
		biasParams.push(`countrycode:${biasByCountryCodes.join(",").toLowerCase()}`);
	}

	if (biasByCircle && isLatitude(biasByCircle.lat) && isLongitude(biasByCircle.lon) && biasByCircle.radiusMeters > 0) {
		biasParams.push(`circle:${biasByCircle.lon},${biasByCircle.lat},${biasByCircle.radiusMeters}`);
	}

	if (biasByRect && isLatitude(biasByRect.lat1) && isLongitude(biasByRect.lon1) && isLatitude(biasByRect.lat2) && isLongitude(biasByRect.lon2)) {
		biasParams.push(`rect:${biasByRect.lon1},${biasByRect.lat1},${biasByRect.lon2},${biasByRect.lat2}`);
	}

	if (biasByProximity && isLatitude(biasByProximity.lat) && isLongitude(biasByProximity.lon)) {
		biasParams.push(`proximity:${biasByProximity.lon},${biasByProximity.lat}`);
	}

	if (biasParams.length) {
		return url + `&bias=${biasParams.join("|")}`;
	} else {
		return url;
	}
}

function isLatitude(num: any): boolean {
	return num !== "" && num !== null && isFinite(num) && Math.abs(num) <= 90;
}

function isLongitude(num: any): boolean {
	return num !== "" && num !== null && isFinite(num) && Math.abs(num) <= 180;
}
